import { StreetOrientation } from "building-types/building/streetOrientationTypesEnum";
import { enumKeys } from "common/utils/enum";

const StreetOrientationNames = enumKeys(StreetOrientation);
export type StreetOrientationName = (typeof StreetOrientationNames)[number];

export function streetOrientationToName(orientation: StreetOrientation | undefined): StreetOrientationName | undefined {
  if (orientation === undefined) {
    return undefined;
  }

  const name = StreetOrientation[orientation];
  if (typeof name !== "string") {
    return undefined;
  }

  return name as StreetOrientationName;
}

export function streetOrientationFromName(name: StreetOrientationName | undefined): StreetOrientation | undefined {
  if (name === undefined) {
    return undefined;
  }

  return StreetOrientation[name];
}
